module.exports = __webpack_public_path__ + "img/图片22.2ae861b4.png";